export default {
    webhooksIndex: { method: 'get',    url: 'webhooks' },
    webhooksShow: { method: 'get',    url: 'webhooks/{id}' },
    webhooksStore: { method: 'post',    url: 'webhooks' },
    webhooksUpdate: { method: 'put',    url: 'webhooks/{id}' },
    webhooksDestroy: { method: 'delete',    url: 'webhooks/{id}' },
    webhookEventsIndex: { method: 'get',    url: 'webhooks/events' },
    webhookCallReload: { method: 'post',    url: 'webhooks/reload' },
    webhookActionLogsPayload: { method: 'get',    url: 'webhooks/action-logs/{id}/payload' },
    webhookActionLogsReload: { method: 'post',    url: 'webhooks/action-logs/{id}/reload' },
    webhookProcess: { method: 'post',    url: 'webhooks/reprocess' }
}
